import {
  Linking,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
} from 'react-native';
import { ThemedPressable, ThemedView } from '../../theme';
import BackButton from '../../sharedComponents/BackButton/BackButton';
import Typography from '../../sharedComponents/typography/Typography';
import { ColorTokens, TypographyTypeDLS } from '@voltmoney/schema';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '../../navigationApp/types';
import EmailIcon from '../../../assets/Icons/Email';
import { CaretRight } from '../../sharedComponents/Icons';
import WhatsAppIcon from '../../../assets/Icons/Whatsapp';
import PhoneIcon from '../../../assets/Icons/PhoneIcon';
import gs from '../../styles/globalStyles';
import classes from '../../styles/globalClasses';
import ScreenWrapper from '@app/hoc/ScreenWrapper';
import { useAppSelector } from '@app/store/hooks';
import {showWhatsapp} from "@voltmoney/micro-frontend/lib/configs/uri-config-utils";

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'CONTACT_US'>;

const bgColor = 'rgba(20, 52, 203, 1)';

const ContactUs = ({ navigation , route, props }: ScreenProps) => {
  const {platformParams} = useAppSelector((state) => state); 
  const { emailData,waData,showCall,callData, showWA ,platform} = platformParams;
  
  const getContactNumberForCall = (defaultNum:string) =>{
    if (platform === 'FREO') {
      return '+916364465607'
    } else if (platform === 'JUPITER') {
        return '+918655055086'
    } else {
        return defaultNum
    }
  }


  const getContactNumberForWhatsapp = (defaultNum: string) => {
    if (platform === 'FREO') {
        return '916364465607'
    } else if(platform === 'JUPITER') {
        return '918655055086'
    } else {
        return defaultNum
    }
  }

  const onWhatsappPress = () => {
    const waNum = getContactNumberForWhatsapp(waData)
    if (Platform.OS === 'web') {
      window.open(`https://wa.me/${waNum}`, '_blank');
    } else {
      Linking.openURL(`whatsapp://send?phone=+${waNum}&text=Hi`);
    }
  };

  const onEmailPress = () => {
    if (Platform.OS === 'web') {
      window.open(`mailto:${emailData}`, '_blank');
    } else {
      Linking.openURL(`mailto:${emailData}`);
    }
  };

  const onCallPress = () => {
    if (Platform.OS === 'web') {
      window.open(`tel:${platform==='JUPITER'? '+918655055086':callData}`,'_parent');
    } else {
      Linking.openURL(`tel:${platform==='JUPITER'? '+918655055086':callData}`);
    }
  }

  const details = (
    <ThemedView padding="lg">
    <Typography
      typeDLS={TypographyTypeDLS.H4S}
      label={'Reach out to us'}
      color={ColorTokens.Grey_Night}
    />
    <ThemedView mb="xs" mt="sm">
      <Typography
        typeDLS={TypographyTypeDLS.B1R}
        label={
          !showCall
            ? 'We would love to hear from you. You can get back to us via Email or WhatsApp.' :
              !showWA ? 'We would love to hear from you. You can get back to us via Call or Email.'
            : 'We would love to hear from you. You can get back to us via Call, Email or WhatsApp.'
        }
        color={ColorTokens.Grey_Charcoal}
      />
    </ThemedView>
      {showWA && (<View
        style={[
          gs.spaceBetween,
          gs.flexRow,
          ls.container,
          gs.alignItemsCenter,
        ]}>
        <Pressable
          style={[gs.flexRow, gs.alignItemsCenter, gs.flexOne]}
          onPress={onWhatsappPress}>
          <WhatsAppIcon size={24} />
          <View style={[gs.setMarginHorizontal(12), gs.flexOne]}>
          <View style={gs.setMarginBottom(4)}>
          <Typography
                typeDLS={TypographyTypeDLS.B1S}
                label={'WhatsApp'}
                color={ColorTokens.Grey_Night}
            />
            </View>
            <Typography
                typeDLS={TypographyTypeDLS.B2R}
                label={`We usually reply within 5-10 mins. We’re available on Mon-Sat from 9:30 AM to 6:30 PM`}
                color={ColorTokens.Grey_Charcoal}
            />
          </View>
        </Pressable>
        <CaretRight size={16} color="rgb(20, 52, 203)" />
      </View>
      )}
    {showCall&&
      (<View
        style={[
          gs.spaceBetween,
          gs.flexRow,
          ls.container,
          gs.alignItemsCenter,
        ]}>
        <Pressable
          style={[gs.flexRow, gs.alignItemsCenter, gs.flexOne]}
          onPress={onCallPress}>
          <PhoneIcon size={24} />
          <View style={[gs.setMarginHorizontal(12), gs.flexOne]}>
          <View style={gs.setMarginBottom(4)}>
          <Typography
                typeDLS={TypographyTypeDLS.B1S}
                label={'Call'}
                color={ColorTokens.Grey_Night}
            />
            </View>
            <Typography
                typeDLS={TypographyTypeDLS.B2R}
                label={`Call us at ${getContactNumberForCall(callData)}. We’re available on Mon-Sat from 9:30 AM to 6:30 PM`}
                color={ColorTokens.Grey_Charcoal}
            />
          </View>
        </Pressable>
        <CaretRight size={16} color="rgb(20, 52, 203)" />
      </View>)}
      <View
        style={[
          gs.spaceBetween,
          gs.flexRow,
          ls.container,
          gs.alignItemsCenter,
        ]}>
        <Pressable
          style={[gs.flexRow, gs.alignItemsCenter, gs.flexOne]}
          onPress={onEmailPress}>
          <EmailIcon size={24} />
          <View style={[gs.setMarginHorizontal(12), gs.flexOne]}>
          <View style={gs.setMarginBottom(4)}>
          <Typography
                typeDLS={TypographyTypeDLS.B1S}
                label={'Email us'}
                color={ColorTokens.Grey_Night}
            />
            </View>
            <Typography
                typeDLS={TypographyTypeDLS.B2R}
                label={`Email us at ${platform==='JUPITER' ? 'support@jupiter.money' : emailData}. We usually respond within 2 hours`}
                color={ColorTokens.Grey_Charcoal}
            />
          </View>
        </Pressable>
        <CaretRight size={16} color="rgb(20, 52, 203)" />
      </View>
    
  </ThemedView>
  )
  if(route===undefined){
    return details
  }
  return (
    <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute : true }}>
    <ThemedView bg="bg-surface-primary" flex={1}>
      <ThemedView
        borderBottomWidth={1}
        borderBottomColor="border-secondary"
        p="lg"
        flexDirection="row"
        alignItems="center">
        <ThemedView mr='md'>
          <BackButton navigation={navigation} />
        </ThemedView>
        <Typography label="Contact us" color={ColorTokens.Grey_Night} />
      </ThemedView>
      {details}
    </ThemedView>
    </ScreenWrapper>
  );
};

export default ContactUs;

const ls = StyleSheet.create({
  container: {
    borderColor: '#d0d6f5',
    backgroundColor: '#fafbfe',
    borderRadius: 12,
    borderWidth: 1,
    marginTop: 16,
    padding: 16,
  },
});
